const BodyModelNew = require("./containers/BodyModelNew");
const Authenticate = require("../utils").authenticate;

// Sync route definition
module.exports = {
    path: "/body-model/new",
    component: Authenticate(BodyModelNew),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/body-model-new/index.js